import React from 'react';
import styled from 'styled-components';

import { useMedia } from '@tager/web-core';

import DetailedCarColor from '@/components/DetailedCarColor';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';

function Color() {
  const isLaptopOnly = useMedia('(max-width: 1539px) and (min-width: 1260px)');
  const isMobile = useMedia('(max-width: 767px)');
  const data = useTypedSelector(selectDetailedCarData);

  if (!data || !data.params.color) {
    return null;
  }

  const {
    params: { color },
  } = data;

  return (
    <Component>
      <DetailedCarColor
        label={color.label}
        hex={color.hex}
        isMobile={isLaptopOnly || isMobile}
      />
    </Component>
  );
}

export default Color;

const Component = styled.div`
  margin-top: 15px;
`;
